import { useState, useEffect } from 'react';
import Login from './components/Login/Login';
import LogoutLink from './components/Logout/Logout';
import OperatorSelector from './components/OperatorSelector/OperatorSelector';
import BookingActions from './components/Bookings/BookingActions';
import ReAuthModal from './components/ReAuthModal/ReAuthModal';
import './global.css';


const App = () => {
  const [token, setToken] = useState(localStorage.getItem("accessToken"));
  const [operatorId, setOperatorId] = useState("");
  const [operators, setOperators] = useState([]);
  const [showReAuthModal, setShowReAuthModal] = useState(false);
  const [authLoading, setAuthLoading] = useState(false);
  const [authError, setAuthError] = useState("");

  // Show re-auth modal after 50 minutes
  useEffect(() => {
    if (token) {
      const timer = setTimeout(() => setShowReAuthModal(true), 50 * 60 * 1000);
      return () => clearTimeout(timer);
    }
  }, [token]);

  const handleReAuth = async () => {
    const expiresIn = localStorage.getItem("expiresIn");
    const tokenSetTime = Number(localStorage.getItem("tokenSetTime") || 0);
    if (
      token &&
      expiresIn &&
      tokenSetTime + Number(expiresIn) * 1000 < Date.now()
    ) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("expiresIn");
      localStorage.removeItem("tokenSetTime");
      setToken(null);
      setOperatorId("");
      setShowReAuthModal(false);
      return;
    }
    setShowReAuthModal(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("expiresIn");
    localStorage.removeItem("tokenSetTime");
    sessionStorage.clear();
    setToken(null);
    setOperatorId("");
    setShowReAuthModal(false);
  };

  // Store the time when token is set
  const handleAuthenticated = (newToken) => {
    if (newToken) {
      setToken(newToken);
      localStorage.setItem("tokenSetTime", Date.now().toString());
      setShowReAuthModal(false);
      setAuthLoading(false);
    }
  };

  return (
    <div className="centered-container">
      <div className="centered-content">
        <h1 style={{ marginBottom: "2rem", color: "#1976d2", textAlign: "center" }} >OneConnect Admin - Booking Report</h1>
        {authLoading ? (
          <div className="spinner" style={{ margin: "4rem auto", display: "block" }} />
        ) : !token ? (
          <Login onAuthenticated={handleAuthenticated} setAuthLoading={setAuthLoading} authError={authError}
            setAuthError={setAuthError}
          />
        ) : (
          <>
            <LogoutLink onLogout={handleLogout} />
            <OperatorSelector operators={operators} setOperators={setOperators} onSelect={setOperatorId} />
            <BookingActions operators={operators} operatorId={operatorId}
            enablePaginated={!!operatorId}
            enableLoadAll={!operatorId}
            
            />
            <ReAuthModal
              show={showReAuthModal}
              onConfirm={handleReAuth}
              onCancel={handleLogout}
              onAuthenticated={handleAuthenticated}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default App;